import { useMemo } from "react";

export const useServiceIDLookup = allowedServices => {
  return useMemo(() => {
    return allowedServices.reduce((acc, service) => {
      acc[service.name.trim().toLowerCase()] = {
        term_id: service.term_id.toString(),
        display_service: parseInt(service.display_service, 10),
        display_room_care: parseInt(service.room_care_options, 10),
        display_payment: parseInt(service.reimbursement_options, 10),
        display_amenities: parseInt(service.amenities_options, 10),
        display_adv_search: parseInt(service.advanced_search_options, 10),
        days_available: parseInt(service.days_available, 10)
      };
      return acc;
    }, {});
  }, [allowedServices]);
};
